var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "white",
    stroke: "#FF9FD3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3641 12.6361C28.0164 14.2882 28.9614 16.5182 28.9993 18.8545C29.0372 21.1908 28.1649 23.4502 26.5671 25.1551L26.3641 25.3651L22.1211 29.6071C21.5827 30.1451 20.8599 30.4584 20.0992 30.4834C19.3385 30.5085 18.5967 30.2435 18.0241 29.7421L17.8801 29.6071L13.6361 25.3641C11.9482 23.6762 11 21.387 11 19.0001C11 16.6131 11.9482 14.3239 13.6361 12.6361C15.3239 10.9482 17.6131 10 20.0001 10C22.387 10 24.6762 10.9482 26.3641 12.6361ZM20.0001 16.0001C19.6061 16.0001 19.216 16.0777 18.852 16.2284C18.488 16.3792 18.1573 16.6002 17.8787 16.8787C17.6002 17.1573 17.3792 17.488 17.2284 17.852C17.0777 18.216 17.0001 18.6061 17.0001 19.0001C17.0001 19.394 17.0777 19.7841 17.2284 20.1481C17.3792 20.5121 17.6002 20.8428 17.8787 21.1214C18.1573 21.4 18.488 21.6209 18.852 21.7717C19.216 21.9225 19.6061 22.0001 20.0001 22.0001C20.7957 22.0001 21.5588 21.684 22.1214 21.1214C22.684 20.5588 23.0001 19.7957 23.0001 19.0001C23.0001 18.2044 22.684 17.4413 22.1214 16.8787C21.5588 16.3161 20.7957 16.0001 20.0001 16.0001Z",
    fill: "#FF3093"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.73118198890b249a7753eca8e3c8bc28.svg";
export { ForwardRef as ReactComponent };